function format(phone){
  if(!phone) return ''
  return phone.slice(0,3) + '-' + phone.slice(3,6) + '-' + phone.slice(6, phone.length) 
}

module.exports = {
  format:format
}
